module.exports = __webpack_public_path__ + "img/P23.7d30f6cc.png";